import React from 'react';
import { ChevronDown } from 'lucide-react';

// 婚姻状况选择组件
const MaritalStatusSelect = ({ label = "婚姻状况", value, onChange, required = false }) => {
  return (
    <div className="mb-4">
      <label className="block text-sm font-medium text-gray-700 mb-2">
        {label}
        {required && <span className="text-red-500 ml-1">*</span>}
      </label>
      <div className="relative">
        <select
          value={value}
          onChange={(e) => onChange(e.target.value)}
          className="w-full h-12 px-4 py-3 pr-10 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent bg-gradient-to-r from-white to-gray-50 shadow-sm hover:shadow-md transition-all duration-200 appearance-none cursor-pointer"
        >
          <option value="">请选择</option>
          <option value="M">已婚</option>
          <option value="S">单身</option>
          <option value="W">丧偶</option>
          <option value="D">离婚</option>
        </select>
        <div className="absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none">
          <ChevronDown className="h-5 w-5 text-gray-400" />
        </div>
      </div>
    </div>
  );
};

export default MaritalStatusSelect; 